import React from 'react';
import { func, shape } from 'prop-types';
import { Col, Image } from 'react-bootstrap';

import { Text } from 'Component/Ajaib';
import { PopUpCenter } from 'Component/PopUp';
import { noop } from '@ajaibid/utils';
import stylesGlobal from '@screens/style';
import { Button } from '@ajaibid/components';

const PopupInfoPayment = ({ infoPaymentData, hideModal }) => {
  return (
    <PopUpCenter show={infoPaymentData.isOpen} onHide={hideModal} title="">
      <Col className="p-0 text-center" style={stylesGlobal.dGrid}>
        <div className="text-center">
          <Image
            style={{
              maxWidth: infoPaymentData.title ? '360px' : '100%',
              borderRadius: 8,
            }}
            src={infoPaymentData.img}
          />
        </div>
        <Text size="title" className="mt-16 text-body-bold">
          {infoPaymentData.title}
        </Text>
        <Text className="mt-16">{infoPaymentData.content}</Text>
        <Button variant="primary" className="mt-16" onClick={() => hideModal()}>
          Mengerti
        </Button>
      </Col>
    </PopUpCenter>
  );
};

PopupInfoPayment.propTypes = {
  infoPaymentData: shape({}),
  hideModal: func,
};

PopupInfoPayment.defaultProps = {
  infoPaymentData: {},
  hideModal: noop,
};

export default PopupInfoPayment;
